import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="footer">


      <div className="container">
        <div className="footer-content">
          {/* Column 1: Logo, Address, Contact, Social */}
          <div className="footer-section about">
            <div className="footer-logo">
              <img src="/images/1-1white.png" alt="KUS GRUP Logo" />
            </div>

            <div className="contact-info-compact">
              <p><i className="fas fa-map-marker-alt"></i> {t('footer.address')}</p>
              <p><i className="fas fa-phone"></i> +90 549 693 58 58</p>
              <p><i className="fas fa-envelope"></i> info@kusgrup.com.tr</p>
            </div>

            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Menus */}
          <div className="footer-section links">
            <h3>{t('footer.quick_links')}</h3>
            <ul>
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/about">{t('nav.about')}</Link></li>
              <li><Link to="/group-companies">{t('nav.group_companies')}</Link></li>
              <li><Link to="/products">{t('nav.products')}</Link></li>
              <li><Link to="/references">{t('nav.references')}</Link></li>
              <li><Link to="/exports">{t('nav.exports')}</Link></li>
              <li><Link to="/contact">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Column 3: Group Companies */}
          <div className="footer-section companies">
            <h3>{t('footer.companies')}</h3>
            <ul>
              <li><a href="https://kusgrup.com.tr" target="_blank" rel="noopener noreferrer">KUS GRUP</a></li>
              <li><a href="https://marmarateknikmakine.com.tr/" target="_blank" rel="noopener noreferrer">Marmara Teknik Makine</a></li>
              <li><a href="https://gebzepalet.com.tr/" target="_blank" rel="noopener noreferrer">Gebze Palet</a></li>
            </ul>
          </div>

          {/* Column 4: Yerli Uretim */}
          <div className="footer-section ">
            <div className="yerli-logo-container">
              <img src="/yuretim.png" alt="Yerli Üretim" />
            </div>
          </div>
        </div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <p>&copy; {currentYear} KUS GRUP. {t('footer.rights')}</p>
          <div className="agency-credit">
            <span>Powered by</span>
            <a href="https://kanguroo.com.tr/" target="_blank" rel="noopener noreferrer">
              Kanguroo Dijital Medya Ajansı
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 
